import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-CareerOpportunities',
    templateUrl: './CareerOpportunities.component.html',
    styleUrls: ['./CareerOpportunities.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CareerOpportunitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
